import React, { Component } from 'react';
import { css } from '@emotion/react';

import { Drawer, Button, IconButton } from "@mui/material"
import { styled } from "@mui/material/styles"
import { observer, Provider } from "mobx-react";
import Sequencer from './Sequencer'
import ThemeProviderWrapper from './ThemeProviderWrapper'
import SFSnackbar from "./SFSnackbar"

import snackbarStore from "../stores/snackbarStore";
import sampleStore from "../stores/sampleStore";
import userStore from "../stores/userStore";
import User from "../models/user";

const ButtonContainer = styled('div')`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1500;
  box-shadow: 0 2px 8px 6px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 5px 20px;
  border-radius: 10px 10px 0 0;
`

const SFDrawer = styled(Drawer)`
  .MuiPaper-root {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  }
`

const CloseIcon = styled("div")`
  cursor: pointer;
  font-weight: 300;
  font-size: 25px;
  color: #757575;
  text-align: center;
`

const SFIconButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  padding: 20px;
`

const stores = {
  sampleStore,
  userStore,
  snackbarStore,
};

@observer
export default class BottomDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isDrawerOpen: sampleStore.showSequencer,
    };

    if (!sampleStore.showBatchEditButton) {
      sampleStore.showSampleSelect = sampleStore.showSequencer
    }

    if (props.currentUser) {
      userStore.currentUser = new User(props.currentUser);
    }
  }


  toggleDrawer = () => {
    this.setState({ isDrawerOpen: !this.state.isDrawerOpen});
    sampleStore.toggleSequencer()
  }

  render() {
    const { isDrawerOpen } = this.state;
    const selectedSamples = sampleStore.selectedSamplesForSequencer;

    return (
      <Provider {...stores}>
        <ThemeProviderWrapper>
          { !isDrawerOpen &&
            <ButtonContainer>
              <Button onClick={this.toggleDrawer}>
                Open Sequencer
              </Button>
            </ButtonContainer>}

          <SFDrawer
            variant="persistent"
            anchor="bottom"
            open={isDrawerOpen}
          >
            <div style={{ margin: '0 auto' }}>
              <div
                css={css`
                  display: flex;
                  justify-content: space-between;
                  align-items: baseline;
                `}>
                {selectedSamples && selectedSamples.length > 0 ? (
                  <Sequencer/>
                  ) : (
                    <div className='container'><p>Please select samples to use the sequencer.</p></div>
                  )}
                { isDrawerOpen &&
                  <SFIconButton onClick={this.toggleDrawer}>
                    <CloseIcon>
                      <i className="fa fa-angle-down"></i>
                    </CloseIcon>
                  </SFIconButton>}
              </div>
            </div>
          </SFDrawer>
          <SFSnackbar />
        </ThemeProviderWrapper>
      </Provider>
    );
  }
}
